import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const DoneOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.91 12c0-4.36-3.55-7.91-7.91-7.91S4.09 7.64 4.09 12s3.55 7.91 7.91 7.91 7.91-3.55 7.91-7.91ZM2.29 12c0-5.36 4.35-9.71 9.71-9.71 5.36 0 9.71 4.35 9.71 9.71 0 5.36-4.35 9.71-9.71 9.71-5.36 0-9.71-4.35-9.71-9.71Zm13.906-2.095a.8.8 0 0 0-1.132-1.13l-4.815 4.823-1.763-1.764a.8.8 0 0 0-1.132 1.132l2.33 2.33a.8.8 0 0 0 1.132 0l5.38-5.39Z"
      fill={color}
    />
  </Svg>
)

export default DoneOutlined
